import React, {useEffect, useState} from "react";
import PageNameV2 from "../common/PageNameV2";
import PageTitleV2 from "../common/PageTitleV2";
import {useApplicationDetail} from "../../../static/js/hock/applicationHock";
import {resultUrls1} from "../../../static/js/Common";
import {setChecked, setValue} from "../../../static/js/Common2";
import {subNavEvent} from "../../../static/js/service/commonService";
import {brNumberFormat, crNumberFormat, telFormat} from "../../../static/js/service/formatService";
import ShopCategoryV2 from "./ShopCategoryV2";
import {bankNameChange} from "../../../static/js/BankVal";

export default function ShopApplicationDetailV2() {
  const [loginId, setLoginId] = useState("");
  const [shopName, setShopName] = useState("");
  const [realName, setRealName] = useState("");
  const [service, setService] = useState(1);
  const [bizTp, setBizTp] = useState(1);
  const [bizNo, setBizNo] = useState("");
  const [corpNo, setCorpNo] = useState("");
  const [cond, setCond] = useState("");
  const [item, setItem] = useState("");
  const [shopTel, setShopTel] = useState("");
  const [road, setRoad] = useState("");
  const [addressDetail, setAddressDetail] = useState("");
  const [reptName, setReptName] = useState("");
  const [birth, setBirth] = useState("");
  const [reptTel, setReptTel] = useState("");
  const [email, setEmail] = useState("");
  const [deliType, setDeliType] = useState("");
  const [bankType, setBankType] = useState("");
  const [acntHolder, setAcntHolder] = useState("");
  const [bankAcnt, setBankAcnt] = useState("");
  const shopId = resultUrls1();

  useApplicationDetail({
    setLoginId, setShopName, setRealName, setService, setBizTp,
    setBizNo, setCorpNo, setCond, setItem, setShopTel,
    setRoad, setAddressDetail, setReptName, setBirth, setReptTel,
    setEmail, setDeliType, setBankType, setAcntHolder, setBankAcnt
  }, shopId);

  useEffect(() => {
    subNavEvent("shopNav", "shop4");

    // 라디오 버튼 체크
    setChecked(`serviceTp${service}`, true);
    setChecked(`bizTp${bizTp}`, true);

    const deliAppType = deliType.split("");

    deliAppType.forEach((value, index) => {
      if(value === "1") {
        setChecked(`deliveryType${index + 1}`, true);
      }
    });

    const bankName = bankNameChange(bankType);
    setValue("bankName", bankName);

  }, [service, bizTp, deliType, bankType]);

  return (
    <main id="ShopApplicationNewV2" className="mainV2">
      <div className="container">
        <section className="containerInner">
          <PageNameV2 title1="상점 관리" title2="상점 신청 현황" />
          <div className="pageTitle mb-10 d-flex a-center j-between">
            <PageTitleV2 title="상점 신청 현황" countText="" count="" unit="" />
          </div>

          <div className="listBox infoBox2 bg-white mb-20">
            <div className='infoBoxTitle font17 fontB'>사업자 정보</div>
            {/*<div className='infoContainer'>
              <div className='infoTitle'>채널명</div>
              <div className='infoInputBox'>동백통</div>
            </div>*/}
            <div className='infoContainer'>
              <div className='infoTitle'>아이디</div>
              <div className='infoInputBox'>
                <input type='text' defaultValue={loginId} readOnly />
              </div>
            </div>
            {/*<div className='infoContainer'>
              <div className='infoTitle'>비밀번호</div>
              <div className='infoInputBox'>
                <input type='password' name='shopPw1' id='shopPw1' readOnly />
              </div>
            </div>*/}
            <div className='infoContainer'>
              <div className='infoTitle'>상점명</div>
              <div className='infoInputBox'>
                <input type='text' defaultValue={shopName} readOnly />
              </div>
            </div>
            <div className='infoContainer'>
              <div className='infoTitle'>실제 상점명</div>
              <div className='infoInputBox'>
                <input type='text' defaultValue={realName} readOnly />
              </div>
            </div>
            <div className='infoContainer'>
              <div className='infoTitle'>서비스 유형</div>
              <div className='infoInputBox'>
                <input type='radio' name='serviceTp' className='infoRadio serviceTp' value={1} id='serviceTp1' disabled />
                <label htmlFor='serviceTp1' className='marginRight15 serviceTpLabel serviceTpLabel1'>배달/포장</label>
                <input type='radio' name='serviceTp' className='infoRadio serviceTp' value={6} id='serviceTp6' disabled />
                <label htmlFor='serviceTp6' className='serviceTpLabel serviceTpLabel6'>택배배송</label>
              </div>
            </div>
            <div className='infoContainer'>
              <div className='infoTitle'>사업자 구분</div>
              <div className='infoInputBox'>
                <input type='radio' name='bizTp' className='infoRadio bizTp' value={1} id='bizTp1' disabled />
                <label htmlFor='bizTp1' className='marginRight15 active bizTpLabel bizTpLabel1'>일반 사업자</label>
                <input type='radio' name='bizTp' className='infoRadio bizTp' value={2} id='bizTp2' disabled />
                <label htmlFor='bizTp2' className='bizTpLabel bizTpLabel2'>법인 사업자</label>
              </div>
            </div>
            <div className='infoContainer'>
              <div className='infoTitle'>사업자등록번호</div>
              <div className='infoInputBox'>
                <input type='text' defaultValue={brNumberFormat(bizNo)} readOnly />
              </div>
            </div>
            <div className='infoContainer'>
              <div className='infoTitle'>법인등록번호</div>
              <div className='infoInputBox'>
                <input type='text' defaultValue={crNumberFormat(corpNo)} readOnly />
              </div>
            </div>
            <div className='infoContainer'>
              <div className='infoTitle'>업태</div>
              <div className='infoInputBox'>
                <input type='text' defaultValue={cond} readOnly />
              </div>
            </div>
            <div className='infoContainer'>
              <div className='infoTitle'>종목</div>
              <div className='infoInputBox'>
                <input type='text' defaultValue={item} readOnly />
              </div>
            </div>
            <div className='infoContainer'>
              <div className='infoTitle'>상점 연락처</div>
              <div className='infoInputBox'>
                <input type='text' defaultValue={telFormat(shopTel)} readOnly />
              </div>
            </div>
            <div className='infoContainer bottomLine'>
              <div className='infoTitle'>상점 주소</div>
              <div className='infoInputBox'>
                <input type='text' defaultValue={road} readOnly />
                <input type='text' defaultValue={addressDetail} className='ml-10' readOnly />
              </div>
            </div>
            <div className='infoContainer'>
              <div className='infoTitle'>대표자 성명</div>
              <div className='infoInputBox'>
                <input type='text' defaultValue={reptName} readOnly />
              </div>
            </div>
            <div className='infoContainer'>
              <div className='infoTitle'>대표자 생년월일</div>
              <div className='infoInputBox'>
                <input type='text' defaultValue={birth} readOnly />
              </div>
            </div>
            <div className='infoContainer'>
              <div className='infoTitle'>대표자 연락처</div>
              <div className='infoInputBox'>
                <input type='text' defaultValue={telFormat(reptTel)} readOnly />
              </div>
            </div>
            <div className='infoContainer last'>
              <div className='infoTitle'>대표자 이메일</div>
              <div className='infoInputBox'>
                <input type='text' defaultValue={email} readOnly />
              </div>
            </div>
          </div>

          <div className="listBox infoBox2 bg-white mb-20">
            <div className='infoBoxTitle font17 fontB'>입점 정보</div>
            <div className='infoContainer'>
              <div className='infoTitle'>카테고리</div>
              <div className='infoInputBox'>
                <ul id='categoryListBox'>
                  <ShopCategoryV2 shopId={ shopId } />
                </ul>
              </div>
            </div>
            <div className='infoContainer last'>
              <div className='infoTitle'>배송방법<span>(중복 가능)</span></div>
              <div className='infoInputBox'>
                {service === 1 &&
                  <>
                    <input type='checkbox' className='inputChk deliveryType modiShop' value={1} id='deliveryType1' disabled />
                    <label htmlFor='deliveryType1' className='checkboxLabel modiShop marginRight18'>배달주문</label>
                    <input type='checkbox' className='inputChk deliveryType modiShop' value={2} id='deliveryType2' disabled />
                    <label htmlFor='deliveryType2' className='checkboxLabel modiShop marginRight18'>포장주문</label>

                  </>
                }
                {service === 6 &&
                  <>
                    <input type='checkbox' className='inputChk deliveryType modiMall' value={4} id='deliveryType4' disabled />
                    <label htmlFor='deliveryType4' className='checkboxLabel modiMall'>택배배송</label>
                  </>
                }
              </div>
            </div>
          </div>

          <div className="listBox infoBox2 bg-white">
            <div className='infoBoxTitle fs-18 fw-7 d-flex a-center'>정산 정보</div>
            <div className='infoContainer d-flex a-center'>
              <div className='infoTitle mr-10'>은행명</div>
              <div className='infoInputBox'>
                <input type='text' id="bankName" readOnly />
              </div>
            </div>
            <div className='infoContainer'>
              <div className='infoTitle mr-10'>예금주 성함</div>
              <div className='infoInputBox'>
                <input type='text' defaultValue={acntHolder} readOnly />
              </div>
            </div>
            <div className='infoContainer last'>
              <div className='infoTitle mr-10'>계좌번호</div>
              <div className='infoInputBox'>
                <input type='text' defaultValue={bankAcnt} readOnly />
              </div>
            </div>
          </div>

          <div className='infoBottomBtnBox'>
            <button type='button' className='infoBottomBtn' onClick={() => window.history.back()}>목록</button>
          </div>

        </section>
      </div>
    </main>
  )
}